import { render, staticRenderFns } from "./buttons-item.vue?vue&type=template&id=48bc1394&"
import script from "./buttons-item.vue?vue&type=script&lang=js&"
export * from "./buttons-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports